// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"2":"88624eff","34":"cfde8053","446":"8b0096b4","453":"ed3810f9","460":"2cba2023","513":"ce6deba6","657":"9aa4941f","714":"acdb4f41","743":"ece40f5c","744":"a783c7af","837":"f317faa3"}[chunkId] + ".chunk.js";
};